import React from "react"
import { Link } from "gatsby"
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa"

import FooterStyles from "./footer.module.scss"

const Footer = () => {
  return (
    <footer className={FooterStyles.footer}>
      <div>
        <h4>Eclipperz</h4>
        <div>
          {/*
          <FaFacebook className={FooterStyles.socialIcon} />
          <FaFacebook className={FooterStyles.socialIcon} />
          <FaTwitter className={FooterStyles.socialIcon} />
          <FaInstagram className={FooterStyles.socialIcon} /> */}
        </div>
      </div>
      <div>
        <p>
          Powered by &copy; AnsonErvin Inc.
        </p>
      </div>
    </footer>
  )
}

export default Footer
